import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { Queue } from '@rossum/api-client/queues';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Button, Typography } from '@rossum/ui/material';
import { QueueActionsMenu } from '../components/QueueActionsMenu';
import { QueueSettingsBreadcrumbs } from '../components/QueueSettingsBreadcrumbs';
import { QueueSettingsTabs } from '../components/QueueSettingsTabs';

type EditModeHeaderProps = {
  parentPath: string;
  queue: Queue;
  workspaceName: string;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const EditModeHeader = ({
  parentPath,
  queue,
  workspaceName,
  scrollableDivRef,
}: EditModeHeaderProps) => {
  const intl = useIntl();

  return (
    <Header
      scrollableDivRef={scrollableDivRef}
      internal
      tabs={<QueueSettingsTabs value="edit" parentPath={parentPath} />}
      breadcrumbs={
        <QueueSettingsBreadcrumbs
          queue={queue}
          workspaceName={workspaceName}
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'containers.settings.queues.queue.edit',
              }),
            },
          ]}
        />
      }
      buttons={[
        <QueueActionsMenu key="queue-actions" queue={queue} />,
        <Button
          key="open-documents"
          component={RouterLink}
          to={`/queues/${queue.id}`}
          variant="outlined"
          color="secondary"
        >
          {intl.formatMessage({
            id: 'features.queueSettings.openDocuments',
          })}
        </Button>,
      ]}
      title={intl.formatMessage({
        id: 'containers.settings.queues.queue.edit',
      })}
      description={
        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.edit.description',
          })}
        </Typography>
      }
    />
  );
};
